import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import {
  BenefitsAdaIcon,
  BenefitsCustomizableIcon,
  BenefitsDeveloperIcon,
  BenefitsMobileIcon,
  BenefitsSeoIcon,
  BenefitsSpeedIcon,
} from "../../icons/shopify-themes"

const benefitsIcons = {
  mobile: BenefitsMobileIcon,
  customizable: BenefitsCustomizableIcon,
  speed: BenefitsSpeedIcon,
  seo: BenefitsSeoIcon,
  ada: BenefitsAdaIcon,
  developer: BenefitsDeveloperIcon,
}

const ShopifyThemesBenefits = ({ title, items, buttonText }) => {
  const [isActive, setIsActive] = useState(false)

  const benefitsClasses = classNames(
    "benefits container container--products-landing",
    {
      "is-active": isActive,
    }
  )
  const loadMoreClasses = classNames("benefits__button link", {
    hidden: isActive,
  })

  return (
    <section className="benefits-section">
      <div className={benefitsClasses}>
        {title ? <h2 className="benefits__title">{title}</h2> : null}

        <div className="benefits__row">
          {items.map(({ icon, title: itemTitle, text }) => {
            const Icon = benefitsIcons[icon]

            return (
              <div className="benefits__item" key={itemTitle}>
                <div className="benefits__item-icon">
                  {Icon ? <Icon /> : null}
                </div>

                <div className="benefits__item-container">
                  <h4 className="benefits__item-title">{itemTitle}</h4>

                  <p className="benefits__item-text">{text}</p>
                </div>
              </div>
            )
          })}
        </div>

        {buttonText && items.length > 3 ? (
          <button
            className={loadMoreClasses}
            type="button"
            aria-expanded={isActive}
            onClick={() => setIsActive(true)}
          >
            {buttonText}
          </button>
        ) : null}
      </div>
    </section>
  )
}

ShopifyThemesBenefits.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.oneOf(Object.keys(benefitsIcons)).isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  buttonText: PropTypes.string,
}

export default ShopifyThemesBenefits
